import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import { getLocaleWithScript, getRequestInfo } from "@gamedev-web/gamedev-sdk-core";

import { isServerRender } from "./serverContextHelpers";

export const getPathWithoutLocale = (path: string, currentLocale: string) => {
  // Handle the case where the path is only the current locale (e.g. developer.microsoft.com/en-US)
  if (path === `/${currentLocale}`) {
    return "/";
  }

  const extractor = new RegExp(`^(/${currentLocale})?(/.*)$`, "i");

  const match = path.match(extractor);
  return match ? match[2] : path;
};

/** Returns the URL that the app is currently on. */
export const useCurrentUrl = () => {
  const location = useLocation();
  const locale = useSelector(getLocaleWithScript);
  const requestOrigin = useSelector(getRequestInfo).origin;

  if (!isServerRender()) {
    return window.location.href;
  }

  const url = new URL(`/${locale}${location.pathname}`, requestOrigin);
  url.search = location.search;
  return url.toString();
};
